export default __webpack_public_path__ + "static/media/gallery-wip-blade plug_06.e6cd9cce.jpg";